module.exports = __webpack_public_path__ + "img/tomooka_main.87972fdf.jpg";